module.exports = __webpack_public_path__ + "img/DE00973.2f476c10.png";